module.exports = __webpack_public_path__ + "static/media/never-typed.660d1e58.svg";